import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Flex, Button, Text, InputGroup, Input, InputRightElement, SimpleGrid, Alert, AlertIcon } from '@chakra-ui/react';

import * as FiIcons from 'react-icons/fi';

import Pagination from 'src/components/shared/pagination/Pagination';
import Breadcrumbs from 'src/components/shared/breadcrumbs/Breadcrumbs';
import SlidersTable from './Table';
import CreateModal from './actions/CreateModal';
import UpdateModal from './actions/UpdateModal';
import DeleteModal from './actions/DeleteModal';

import { getSliders } from 'src/store/sliders/slidersSlice';

import { Wrapper } from './Styles';

import theme from '../../global/theme';

const Sliders = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const sliders = useSelector(state => state.sliders);

  const [page, setPage] = useState(1);
  const [query, setQuery] = useState("");

  const [showCreateSlider, setShowCreateSlider] = useState(false);
  const [showUpdateSlider, setShowUpdateSlider] = useState(false);
  const [showDeleteSlider, setShowDeleteSlider] = useState(false);

  useEffect(() => {
    dispatch(getSliders({ page, query }));
  }, [dispatch, page, query]);


  return (
    <Wrapper>
      <Breadcrumbs
        currentPage={t('pages.sliders.sliders')}
        pages={[{ name: `${t('pages.dashboard.dashboard')}`, path: '/' }]}
      />

      {sliders.error && (
        <Alert status="error" variant="left-accent" marginBottom={8}>
          <AlertIcon />
          <Text>{sliders.error}</Text>
        </Alert>
      )}

      <SimpleGrid columns={{ sm: 1, md: 2 }} justifyContent="space-between">
        <Flex marginBottom={8}>
          <Button bg="red.600" textTransform="uppercase"
            fontWeight="bold" fontSize={18} marginInlineEnd={4} color="white" _hover={{ bg: 'red.600' }}
            onClick={() => setShowCreateSlider(true)}
          >
            {t('general.create')} +
          </Button>
        </Flex>

        <Flex marginBottom={8} justifyContent="flex-end">
          <InputGroup width="auto">
            <Input auth="auto" type="text" placeholder={t('general.search')}
              bg={theme.light} boxShadow={theme.shadow} color={theme.dark} border="none"
              onChange={(e) => setQuery(e.currentTarget.value)}
            />
            <InputRightElement color={theme.light} children={<FiIcons.FiSearch />} />
          </InputGroup>
        </Flex>
      </SimpleGrid>

      {sliders.itemsCount > 0 ? (
        <SlidersTable
          data={sliders.data}
          page={page}
          handleUpdate={(el) => setShowUpdateSlider(el)}
          handleDelete={(el) => setShowDeleteSlider(el)}
        />
      ) : (
        <Flex textAlign="center" bg={theme.light} boxShadow={theme.shadow} height={200} alignItems="center"
          justifyContent="center" borderRadius={16}>
          <Text fontSize={18} textTransform="capitalize" color="gray.300" fontWeight="bold">
            {t('pages.sliders.no_sliders')}
          </Text>
        </Flex>
      )}

      <Flex justifyContent="flex-end">
        <Pagination
          page={page}
          itemsCount={sliders.itemsCount ?? 0}
          onChange={(page) => setPage(page)}
        />
      </Flex>

      {showCreateSlider && <CreateModal onClose={() => setShowCreateSlider(false)} />}
      {showUpdateSlider && <UpdateModal data={showUpdateSlider} onClose={() => setShowUpdateSlider(false)} />}
      {showDeleteSlider && <DeleteModal data={showDeleteSlider} onClose={() => setShowDeleteSlider(false)} />}
    </Wrapper>
  )
}

export default Sliders